import { render } from "./ActionDisplayFreePopup.vue?vue&type=template&id=11240ef8"
import script from "./ActionDisplayFreePopup.vue?vue&type=script&lang=ts"
export * from "./ActionDisplayFreePopup.vue?vue&type=script&lang=ts"
script.render = render

export default script